<template>
    <section class="tekst blue">
        <circles-layout class="blue"></circles-layout>
        <h1>Medewerker 3.0</h1>
        <p>De kwaliteit van ons onderwijs wordt ingevuld door de medewerkers van Onderwijsgroep Tilburg. Docenten geven onze studenten en leerlingen iedere dag les, maar ook zij moeten zichzelf blijven ontwikkelen en scholen. Dat geldt voor alle medewerkers van Onderwijsgroep Tilburg. Onze medewerker 3.0 is nieuwsgierig, daagt zichzelf uit en, is te allen tijde een teamspeler en toont eigenaarschap. Onze medewerkers van Onderwijsgroep Tilburg hebben een brede kennis, zijn op de hoogte van nieuwe technologieën, zij weten wat er speelt in de eigen omgeving en de regio. Ze zijn in staat om hun kennis met collega’s te delen en te vertalen naar professioneel pedagogisch en didactisch handelen. Alleen dan zijn we in staat om het onderwijs van de toekomst te realiseren en onze ambitie om het beste onderwijs van Nederland na te streven en inhoud te geven.</p>
        <p>Het is belangrijk om de instroom van nieuwe medewerkers te bevorderen. Sinds 2019 is ROC Tilburg een opleidingsschool voor de lerarenopleiding van Fontys en is er een programma ontwikkeld om mensen uit het bedrijfsleven gedeeltelijk in te zetten in het onderwijs; de zogenaamde hybride docent.</p>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'MedewerkerIntro',
        meta: {
            title: 'MedewerkerIntro',
            color: '#36B1CA'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
                // console.log( 'animateIn' );
            }
        }
    };
</script>
